<template lang="pug">
.product-page
  .text-center.mb-3
    .main-title.mb-1.mb-lg-5 {{$t('ui.fishing')}}
  .row
    //- .col-6.col-lg-4.px-0.px-lg-1
      .product-wrap
        router-link(:to="{name: 'fish', params: {game: 'fish'}}")
          .product-single
            .product-pic
              img.w-100.img-fluid(src='img/fishing/neko-fishing.png')
            .product-hover
              img.w-100.img-fluid(src='img/fishing/neko-fishing-hover.png')
    .col-6.col-lg-4.px-0.px-lg-1(v-if="getLive22Status===true")
      .product-wrap
        router-link(to="live22fish")
          .product-single
            .product-pic
              img.w-100.img-fluid(src='img/fishing/live22-fishing.png')
            .product-hover
              img.w-100.img-fluid(src='img/fishing/live22-fishing-hover.png')
    .col-6.col-lg-4.px-0.px-lg-1(v-if="getKkStatus===true")
      .product-wrap
        router-link(to="kingkongfish")
          .product-single
            .product-pic
              img.w-100.img-fluid(src='img/fishing/kingkong-fishing.png')
            .product-hover
              img.w-100.img-fluid(src='img/fishing/kingkong-fishing-hover.png')
</template>
<script>
export default {
  computed:{
    getKkStatus(){
			return this.$store.state.user.account.kk
		},
		getLive22Status(){
			return this.$store.state.user.account.live22
		},
  },
  created(){
		if(this.getKkStatus===false && this.getLive22Status===false){
			this.$router.push("/").catch(error =>{})
		}
	},
  mounted(){
    window.scroll(0,0)
  },
}
</script>
<style lang="scss" scoped>
.active{
  border: 1px solid #8127C5;
}
</style>